import { Component, inject, OnDestroy, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { Router } from "@angular/router";
import { LorenBaseFeature } from "../../../../shared/base-components/loren-base-feature/loren-base-feature";
import { LorenAsset } from "../../../loren-assets/interfaces/loren-asset.interface";
import { LorenTourService } from "../../../../shared/services/loren-tour-service/loren-tour.service";
import { LOREN_ROUTES } from "../../../../shared/constants/loren-routes.constants";
import { Location } from "@angular/common";
import { AssetService } from "../../../asset/asset.service";

/// A LOT OF THINGS IN THIS COMPONENT HAVE BEEN COMMENTED OUT.
/// THIS IS BECAUSE REPORTS ARE NOW MOVED TO THE DETAILS PAGE.
/// THIS COMPONENT WILL BE RECREATED WHEN A FEATURE IS IMPLEMENTED
/// ALLOWING THE USER TO DOWNLOAD A REPORT FOR MORE THAN ONE ASSET.

@Component({
  selector: "loren-asset-reports",
  templateUrl: "./loren-asset-reports.component.html",
  styleUrls: ["./loren-asset-reports.component.scss"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class LorenAssetReportsComponent
  extends LorenBaseFeature
  implements OnInit, OnDestroy {
  private readonly router = inject(Router);
  private readonly location = inject(Location);
  private readonly assetService = inject(AssetService);
  lorenTourService = inject(LorenTourService);

  assets$ = this.assetService.all;
  showAssetsSelectionDialog = false;

  ngOnInit(): void {
    this.showAssetsSelectionDialog = true;
  }

  ngOnDestroy(): void {
    this.showAssetsSelectionDialog = false;
  }

  handleAssetsSelection(assets: LorenAsset[]) {
    this.router.navigateByUrl(
      `/${LOREN_ROUTES.ASSET}/${assets[0].id}#diagrams`
    );
  }

  handleAssetsSelectionCancel() {
    this.location.back();
  }
}
